"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLayoutFullPage = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// todo: remove when ie11 becomes unsupported
var IE11StyledLayoutFullPage = _styledComponents.default.div.withConfig({
  displayName: "LayoutFullPagestyles__IE11StyledLayoutFullPage",
  componentId: "sc-1glvsm9-0"
})(["display:-ms-grid;-ms-grid-columns:auto 1fr;-ms-grid-rows:auto auto;.c-layout-full-page-header{position:relative;-ms-grid-row:1;-ms-grid-column:1;-ms-grid-column-span:2;}.c-layout-full-page-side-nav{-ms-grid-row:2;-ms-grid-column:1;}.c-layout-full-page-content{-ms-grid-row:2;-ms-grid-column:2;}"]);

var StyledLayoutFullPage = (0, _styledComponents.default)(IE11StyledLayoutFullPage).withConfig({
  displayName: "LayoutFullPagestyles__StyledLayoutFullPage",
  componentId: "sc-1glvsm9-1"
})(["margin:0 auto;position:relative;.c-layout-full-page-loader,.c-layout-full-page-loader *{background:transparent;}.c-layout-full-page-header{width:100%;z-index:", ";}.c-layout-full-page-side-nav{display:none;@media only screen and (min-width:", "){display:block;}}.c-layout-full-page-content{min-height:100vh;}.c-layout-full-page-blur,.c-layout-full-page-blur *{opacity:0.4;filter:blur(3px);}@supports (display:grid){&{display:grid;grid-template-areas:\"hd hd\"  \"sn ct\";grid-template-rows:auto auto 1fr;grid-template-columns:auto 1fr;}.c-layout-full-page-header{grid-area:hd;}.c-layout-full-page-side-nav{grid-area:sn;}.c-layout-full-page-content{grid-area:ct;}}"], function (props) {
  return props.theme.menu;
}, function (props) {
  return props.theme.smallBreak;
});
exports.StyledLayoutFullPage = StyledLayoutFullPage;